const events = (arr) => {
  const newArr = arr.map((item) =>
    ({
      allDay: true,
      awayTeam: item.away_team,
      awayTeamLogo: item.away_team_logo,
      end: item.start,
      homeTeam: item.home_team,
      homeTeamLogo: item.home_team_logo,
      id: item.id,
      start: item.start,
      startsAt: item.start,
      state: item.state,
      title: [item.title],
    }));

  return newArr;
};

export default events;
